import React, { useEffect, useState, useMemo } from "react";
import BasicTable from "../maincomponent/reacttable/table";
import Button from "@mui/material/Button";
import axios from "axios";
import "../style/page/patient.scss";
import { DateRangePicker } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import { useNavigate } from "react-router-dom";
import { patientlist } from "../../text/apidata";
import noimage from "../../assets/images/noimage.png";
import { useSelector, useDispatch } from "react-redux";
import { editdoctoruser, patientid, sidebar, pvphno, pbranch } from "../redux/reducer/counterslice";
// import { makeData, Logo, Tips } from "./Utils";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

function Patient({ loaderchange, enableditview, popupalert, popuptext }) {
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [datacount, setdatacount] = useState();
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const viewpatient = useNavigate();
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const locationid = useSelector((state) => state.counter.loginuser_location_id)
  const [branches, setbranches] = useState(locationid == 91 ? "0" : locationid == 90 ? "1" : locationid == 92 ? "2" : "0");
  const [patientcount, setpatientcount] = useState(0);


  const dispatch = useDispatch();
  const patientviewid = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  // console.log(tableheaderdata[0]);
  const [search, setsearch] = useState(false);
  var today = new Date();
  // var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(today);
  const [range, setrange] = useState([gt, it]);
  const dropdownhandlechange = (e, ph, branchname) => {
    if (e) {
      viewpatient("/PatientView");
      patientviewid(patientid(e));
      patientviewid(pvphno(ph));
      if (branchname = "VELACHERY") {
        patientviewid(pbranch("0"));
      } else if (branchname = "CHETPET") {
        patientviewid(pbranch("1"));
      } else {
        patientviewid(pbranch("2"));
      }

    }
  };
  useEffect(() => {
    if (searchQuery != "") {
      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(
        searchQuery
      );
      if (hasNumbers || hasLetters || hasSpecialChars) {
        loaderchange("true");
        axios({
          method: "get",
          url: patientlist,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          params: {
            page: dtpageindex,
            page_size: dtpagesize,
            search: searchQuery,
            branch: branches,
            created_date_min: "1950-01-01",
            created_date_max: "2099-01-01",

          },
        })
          .then((res) => {
            setpatientcount(0)
            setdatacount(res.data.data_count);
            settableheaderdata(res.data.data);
            setpatientcount(res.data.data_count)
            loaderchange("false");
          })
          .catch((error) => {
            console.log(error);
            loaderchange("false");
            // setdtPageindex(dtpageindex-1)
            popupalert("true");
            popuptext("No Data Available");
            setTimeout(() => {
              popupalert("false");
            }, 2000);
          });
      }
    } else {
      loaderchange("true");
      axios({
        method: "get",
        url: patientlist,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
        params: {
          page: dtpageindex,
          page_size: dtpagesize,
          search: searchQuery,
          branch: branches,
          created_date_min: range[0],
          created_date_max: range[1],
        },
      })
        .then((res) => {
          setpatientcount(0)
          setdatacount(res.data.data_count);
          settableheaderdata(res.data.data);
          loaderchange("false");
          console.log(res.data, "test")
          setpatientcount(res.data.data_count)

        })
        .catch((error) => {
          console.log(error);
          loaderchange("false");
          // setdtPageindex(dtpageindex-1)
          popupalert("true");
          popuptext("No Data Available");
          setTimeout(() => {
            popupalert("false");
          }, 2000);
        });
    }
  }, [dtpageindex, dtpagesize, search, searchQuery, branches, range]);

  const columns = useMemo(
    () => [
      {
        Header: "FirstName",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              {/* <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={String(row.row.original.first_name)}
                  onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                  className="doctorname"
                >
                  {row.row.original.titles != null ? String(row.row.original.titles) + "." : "" +
                    String(row.row.original.first_name) +
                    " " +
                    String(row.row.original.last_name)}
                </div>
              </span> */}
              <span style={{ display: "flex" }}>
                <img
                  style={{
                    height: "2.5rem",
                    width: "2.5rem",
                    borderRadius: "50%",
                  }}
                  onClick={(e) => {
                    window.open(
                      row.row.original.profile_pic
                        ? row.row.original.profile_pic
                        : noimage
                    );
                  }}
                  className="pointer"
                  src={
                    row.row.original.profile_pic
                      ? row.row.original.profile_pic
                      : noimage
                  }
                ></img>
                <div
                  style={{ marginTop: "9px", marginLeft: "10px" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={
                    // row.row.original.titles != null ? String(row.row.original.titles) + "." : "" +
                    String(row.row.original.first_name) +
                    " " +
                    String(row.row.original.last_name)
                  }
                  onClick={(e) => dropdownhandlechange(row.row.original.id, row.row.original.phonenumber, row.row.original.branch_display)}
                  className="doctorname"
                >
                  {
                    row.row.original.titles ? `${row.row.original.titles} ` : ''
                  }
                  {
                    `${row.row.original.first_name}  ${row.row.original.last_name}`
                  }
                </div>
              </span>
            </>
          );
        },
      },
      // {
      //   Header: "LastName",
      //   accessor: "",
      //   Cell: (row) => {
      //     // console.log(row.row.original.username)
      //     return (
      //       <>
      //         <span>
      //           <div
      //             style={{ marginTop: "3px" }}
      //             data-tooltip-id="my-tooltip"
      //             data-tooltip-content={String(row.row.original.last_name)}
      //           >
      //             {String(row.row.original.last_name)}
      //           </div>
      //         </span>
      //       </>
      //     );
      //   },
      // },
      {
        Header: "Nationality",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={String(row.row.original.nationality)}
                >
                  {String(row.row.original.nationality)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Email",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={String(row.row.original.email)}
                >
                  {row.row.original.email != null && row.row.original.email != "" ? String(row.row.original.email) : "--"}
                </div>
              </span>
            </>
          );
        },
      },

      {
        Header: "PhoneNumber",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={String(row.row.original.phonenumber)}
                >
                  {String(row.row.original.phonenumber)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "UHID",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={String(row.row.original.p_uhid)}
                >
                  {row.row.original.p_uhid == null
                    ? "--"
                    : row.row.original.p_uhid}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Master",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="admin"
                  data-tooltip-content={
                    row.row.original.is_master == true ? "Yes" : "No"
                  }
                >
                  {row.row.original.is_master == true ? "Yes" : "No"}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Location Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.branch_display}
              >
                {row.row.original.branch_display}{" "}
              </p>
            </>
          );
        },
      },
      {
        Header: "Last login",
        accessor: "",

        Cell: (row) => {
          if (row.row.original.last_login != null) {
            const dateString = row.row.original.last_login;
            const dateObject = new Date(dateString);

            const hours = dateObject.getHours();
            const minutes = dateObject.getMinutes();
            const seconds = dateObject.getSeconds();
            const amOrPm = hours >= 12 ? "PM" : "AM";
            const twelveHourFormat = hours % 12 || 12; // 0 should be converted to 12

            const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;

            return (
              <>
                <p
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={`${formattedTime}`}
                >
                  {`${row.row.original.last_login.slice(0, 10) +
                    "  " +
                    formattedTime
                    }`}
                </p>
              </>
            );
          } else {
            return (
              <p data-tooltip-id="my-tooltip" data-tooltip-content={"--"}>
                {"--"}
              </p>
            );
          }
        },
      },
      {
        Header: "Actions",
        accessor: "",
        // onChange: () => { dropdownhandlechange(e,row) },
        Cell: (row) => {
          return (
            <>
              <button
                type="button"
                class="btn btn-danger btn-sm delete"
                style={{ display: "flex", gap: "4px" }}
                onClick={(e) => dropdownhandlechange(row.row.original.id, row.row.original.phonenumber, row.row.original.branch_display)}
              >
                <i
                  onClick={(e) => dropdownhandlechange(row.row.original.id, row.row.original.phonenumber, row.row.original.branch_display)}
                  class="bi bi-eye-fill"
                ></i>{" "}
                View
              </button>
            </>
          );
        },
      },
    ],
    []
  );

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
  };




  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  const handlechangedate = (name, value) => {
    // let data =value.slice(0, 10)
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };
  const cleaningrange = () => {
    //setrange([gt,it]);
  };
  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },

    {
      label: "Last week",
      closeOverlay: false,
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      appearance: "default",
    },
    {
      label: "Next week",
      closeOverlay: false,
      value: (value, index) => {
        // console.log(value);
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), 7),
        ];
      },
      appearance: "default",
    },
  ];
  return (
    <div
      className={
        sideactive ? "maincontainer-patient-sa" : "maincontainer-patient"
      }
    >
      <div className="patient-header">
        <div className="row">
          <div className="col-sm-7 col-auto">
            <h3 className="page-title">Patient</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a
                  href="/"
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={(e) => {
                    dispatch(sidebar("DashBoard"));
                  }}
                >
                  Dashboard
                </a>
              </li>
              <li className="breadcrumb-item active">Patient</li>
            </ul>
          </div>
          <div class="col-sm-5 col-auto">
            {" "}
            <div className="datepicker_dash">
              <DateRangePicker
                defaultValue={[
                  // new Date(new Date().setDate(today.getDate() - 30)),
                  new Date(),
                  new Date(),
                ]}
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                style={{ width: 270, padding: 10, float: "right" }}
                onClean={(e) => cleaningrange(e)}
                onChange={(e) => {
                  if (e != null) {
                    setrange([]);
                    e.forEach((newValue) => {
                      var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                      var localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      handlechangedate("validtill", localISOTime);
                    });
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-4 col-sm-6 col-12 ">
          <div class="card">
            <div class="card-body" style={{ padding: "1.5rem" }}>
              <div class="dash-widget-header">
                <span class="dash-widget-icon text-success">
                  <i class="bi bi-person-bounding-box"></i>
                </span>
                <div class="dash-count">
                  <h3>{patientcount}</h3>
                  {/* <h3>{pcount}</h3> */}
                </div>
              </div>
              <div class="dash-widget-info">
                <h6 class="text-muted">Patients</h6>
                <div class="progress progress-sm">
                  <div
                    class="progress-bar bg-success"
                    style={{ width: `${patientcount / 10}%` }}
                    aria-valuenow={patientcount}
                    aria-valuemin="0"
                    aria-valuemax="100%"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row" style={{ marginTop: 20 }}>
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="patient">
                <div className="table-content-patient">
                  <form
                    onSubmit={handleSubmit}
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div
                      class="input-group rounded"
                      style={{ width: "250px", height: "40px" }}
                    >
                      <input
                        type="search"
                        class="form-control rounded"
                        aria-label="Search"
                        aria-describedby="search-addon"
                        value={searchQuery}
                        onKeyDown={(e) => {
                          if (e.target.value.length === 0 && e.which === 32) {
                            e.preventDefault();
                          }
                        }}
                        onInput={(e) => {
                          if (e.target.value.length <= "100") {
                            setSearchQuery(e.target.value);
                          } else {
                            e.preventDefault();
                          }
                        }}
                        // onKeyDown={(e)=>{if(e.which=="32"){
                        //   e.preventDefault()
                        // }}}

                        min="0"
                        max="10"
                        label="Search"
                        placeholder="Search..."
                        required
                      />
                      <span
                        class="input-group-text border-0 bg-transparent"
                        id="search-addon"
                      >
                        <i
                          class="bi bi-search"
                          style={{
                            color: "#1b5a90",
                            width: "20px",
                            height: "20px",
                          }}
                        ></i>
                      </span>
                    </div>
                    {/* <div
                      style={{
                        display: "flex",
                        gap: "10px",
                      }}
                    >
                      {roledata == "Super Admin" && (
                        <>
                          <div
                            class="input-group rounded mr-2 "
                            style={{ width: "250px", height: "40px" }}
                          >
                            <select
                              class="form-select"
                              value={branches}
                              name="gender"
                              onChange={(e) => {
                                setbranches(e.target.value);
                              }}
                            >
                              <option selected disabled value="">
                                Filter By Location...
                              </option>
                              <option value={"0"}>VELACHERY</option>
                              <option value={"1"}>CHETPET</option>
                              <option value={"2"}>KOLATHUR</option>
                            </select>
                          </div>
                        </>
                      )}
                    </div> */}
                  </form>

                  <div className="table-patient">
                    <BasicTable
                      columns={columns}
                      data={tableheaderdata}
                      pagesize={pagesize}
                      pageindex={pageindex}
                      dtpagesize={dtpagesize}
                      dtpageindex={dtpageindex}
                      datacount={datacount}
                      location={"patient"}
                      setbranches={setbranches}
                      branches={branches}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ReactTooltip
        id="my-tooltip"
        arrowColor="transparent"
        place="bottom-start"
        delayShow={200}
        style={{
          backgroundColor: "#707070",
          fontSize: "10px",
          textAlign: "center",
          padding: "5px",
          fontWeight: 400,
        }}
      />
    </div>
  );
}

export default Patient;
